import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "house-real-name",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        auth_status: -1
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      adminList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      curAuthInfo: {},
      authInfoDialogVisible: false,
      remarkDialogVisible: false,
      currentRemarkObj: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
            _this.getAdminList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    showAuthInfo: function showAuthInfo(row) {
      this.curAuthInfo = row.auth_info;
      this.authInfoDialogVisible = true;
    },
    // 房源审核
    auditHouse: function auditHouse(row, status) {
      var _this2 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.auditHouse({
                house_id: row.id,
                status: status
              });
            case 1:
              _this2.$message.success("操作成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {});
    },
    getAdminList: function getAdminList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context3.v;
              _this3.adminList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/house/update",
        query: {
          id: row.id,
          userId: row.userInfo.id,
          need_auth: 1
        }
      });
    },
    getUsersTagList: function getUsersTagList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              userIds = [];
              _this4.tableData.forEach(function (item) {
                userIds.push(item.userInfo.id);
              });
              _context5.n = 1;
              return _this4.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context5.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _this4.tableData.forEach(function (item) {
                        if (item.userInfo.id == key) {
                          _this4.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context4.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context5.n = 4;
                break;
              }
              key = _t2.value;
              return _context5.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context5.n = 2;
              break;
            case 4:
              return _context5.a(2);
          }
        }, _callee4);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var price, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pn = 1;
              }
              if (_this5.searchForm.priceId && _this5.searchForm.priceId.length > 0) {
                price = _this5.searchForm.priceId.split(",");
                _this5.searchForm.minPrice = price[0];
                _this5.searchForm.maxPrice = price[1];
              }
              _this5.searchForm.type = 2; // 待审核
              _this5.searchForm.need_auth = 1; // 实名
              _this5.tableLoading = true;
              _context6.n = 1;
              return _this5.$api.getHouseList(_this5.searchForm);
            case 1:
              res = _context6.v;
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.tableLoading = false;
              _this5.getUsersTagList();
              _this5.tableData.forEach(function (item) {
                return item.userId = item.userInfo.id;
              });
              _this5.getUserListByIds(_this5.tableData, "userId", "", "newUser");
            case 2:
              return _context6.a(2);
          }
        }, _callee5);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this6.$api.getHouseFilterType();
            case 1:
              res = _context7.v;
              _this6.filterList = res.data;
            case 2:
              return _context7.a(2);
          }
        }, _callee6);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this7 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this7.searchForm.districtId = "";
            _this7.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      if (row.censor_status == "block") {
        return "warning-row";
      }
      return "";
    }
  }
};